import { ofDeliveryReservationTime } from './DeliveryReservationTime'

const DeliveryReservationOptionsResponse = class {
  constructor({ shopId, reservationAvailable, unavailbleReason, times }) {
    this.shopId = shopId
    this.reservationAvailable = reservationAvailable
    this.unavailbleReason = unavailbleReason
    this.times = times ? times.map(e => ofDeliveryReservationTime(e)) : []
  }

  getDisplayTimes() {
    return this.times.filter(e => e.display)
  }
}

export default null

export const ofDeliveryReservationOptionsResponse = (params = {}) =>
  new DeliveryReservationOptionsResponse(params)
